import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { SignOutComponent } from './sign-out.component';
export var SignOutComponentNgModule = module(baseModuleId + ".sign-out", [])
    .component('signOut', SignOutComponent);
